import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiScoreSuggestionType,
  BackendMutationScoreLongFormAssetArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ScoreLongFormAsset(
    $longFormAssetId: ID!
    $text: String!
    $html: String
    $scoringMethod: ScoringMethodInput
  ) {
    scoreLongFormAsset(
      longFormAssetId: $longFormAssetId
      text: $text
      html: $html
      scoringMethod: $scoringMethod
    ) {
      score
      performancePredictionsScoreLocked
      contentTaxonomyId
      ageScoreHistogram
      genderScoreHistogram
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        name
        type
      }
      secondaryScoringMethod {
        id
        name
        type
      }
    }
  }
`;

type Variables = BackendMutationScoreLongFormAssetArgs;
type Result = BackendMultiScoreSuggestionType;

export const scoreLongFormAsset = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
